import { jsx as t } from "react/jsx-runtime";
import { memo as l } from "react";
import { cva as r } from "class-variance-authority";
import { cn as i } from "../../utils/cn.js";
const s = r("animate-pulse bg-black/10 dark:bg-white/10", {
  variants: {
    size: {
      base: "h-4 w-10",
      headline: "h-5 w-9",
      subhead: "h-3.5 w-8",
      "caption-1": "h-3 w-6",
      "caption-2": "h-2.5 w-5",
      "title-1": "h-7 w-24",
      "title-2": "h-6 w-32"
    },
    rounded: {
      none: "rounded-none",
      sm: "rounded-sm",
      md: "rounded-md",
      lg: "rounded-lg",
      "2xl": "rounded-2xl",
      full: "rounded-full"
    }
  },
  defaultVariants: {
    size: "base",
    rounded: "full"
  }
}), m = l(({ className: e, size: o, rounded: n, style: d, ...a }) => /* @__PURE__ */ t("div", { className: i(s({ size: o, rounded: n }), e), style: d, ...a }));
m.displayName = "Skeleton";
export {
  m as Skeleton
};
//# sourceMappingURL=index.js.map
